export class GetTableDataQualityHealthTrendResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "freshness",
            "baseName": "freshness",
            "type": "DataQualityHealthTrendSignal",
            "format": ""
        },
        {
            "name": "uniqueness",
            "baseName": "uniqueness",
            "type": "DataQualityHealthTrendSignal",
            "format": ""
        },
        {
            "name": "quarantineRate",
            "baseName": "quarantineRate",
            "type": "DataQualityHealthTrendSignal",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityHealthTrendResponse.attributeTypeMap;
    }
    constructor() {
    }
}
